var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.33301 4.98951C5.33301 4.01835 5.33301 3.53277 5.5355 3.2651C5.7119 3.03191 5.98153 2.88761 6.27341 2.87018C6.60844 2.85017 7.01247 3.11953 7.82053 3.65823L18.3361 10.6686C19.0038 11.1137 19.3376 11.3363 19.454 11.6168C19.5557 11.8621 19.5557 12.1377 19.454 12.383C19.3376 12.6635 19.0038 12.886 18.3361 13.3312L7.82053 20.3415C7.01247 20.8802 6.60844 21.1496 6.27341 21.1296C5.98153 21.1122 5.7119 20.9679 5.5355 20.7347C5.33301 20.467 5.33301 19.9814 5.33301 19.0103V4.98951Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.43bcdd25e71163b3bef64a903df97c10.svg";
export { ForwardRef as ReactComponent };